/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Logo_AltInputs */

const en_iconik_logo_alt = /** @type {(inputs: Iconik_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iconik logo`)
};

const fr_iconik_logo_alt = /** @type {(inputs: Iconik_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo Iconik`)
};

const de_iconik_logo_alt = /** @type {(inputs: Iconik_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iconik-Logo`)
};

const it_iconik_logo_alt = /** @type {(inputs: Iconik_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo iconico`)
};

const ru_iconik_logo_alt = /** @type {(inputs: Iconik_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Логотип Iconik`)
};

const es_iconik_logo_alt = /** @type {(inputs: Iconik_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logotipo de Iconik`)
};

const zh_cn2_iconik_logo_alt = /** @type {(inputs: Iconik_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iconik 标志`)
};

const ja_iconik_logo_alt = /** @type {(inputs: Iconik_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iconikロゴ`)
};

const hi_iconik_logo_alt = /** @type {(inputs: Iconik_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आइकॉनिक लोगो`)
};

const pt_pt2_iconik_logo_alt = /** @type {(inputs: Iconik_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logotipo Iconik`)
};

/**
* | output |
* | --- |
* | "Iconik logo" |
*
* @param {Iconik_Logo_AltInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_logo_alt = /** @type {((inputs?: Iconik_Logo_AltInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Logo_AltInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iconik_logo_alt(inputs)
	if (locale === "de") return de_iconik_logo_alt(inputs)
	if (locale === "it") return it_iconik_logo_alt(inputs)
	if (locale === "ru") return ru_iconik_logo_alt(inputs)
	if (locale === "es") return es_iconik_logo_alt(inputs)
	if (locale === "zh-CN") return zh_cn2_iconik_logo_alt(inputs)
	if (locale === "ja") return ja_iconik_logo_alt(inputs)
	if (locale === "hi") return hi_iconik_logo_alt(inputs)
	if (locale === "pt-PT") return pt_pt2_iconik_logo_alt(inputs)
	return en_iconik_logo_alt(inputs)
});